type Replacer = Parameters<typeof JSON.stringify>[1]
type Space = Parameters<typeof JSON.stringify>[2]

export function formatJson(value: string, replacer?: Replacer, space?: Space): string
export function formatJson(value: string | null, replacer?: Replacer, space?: Space): string | null
export function formatJson(
  value: string | null,
  replacer: Replacer = null,
  space: Space = 2,
): string | null {
  if (!value || !couldBeJson(value)) {
    return value
  }

  try {
    return JSON.stringify(JSON.parse(value), replacer, space)
  } catch {
    return value
  }
}

/**
 * Enables small bailout optimization for non-json values, can save a few frames in large tables
 */
export function couldBeJson(value: string): boolean {
  const firstChar = value.trimStart().charAt(0)
  return firstChar === '{' || firstChar === '['
}
